import { CommonProps } from './types';

import { BodyContainer } from './Modal.styles';

function Body({ children, className }: CommonProps) {
	return <BodyContainer className={className}>{children}</BodyContainer>;
}

export { Body };
